<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {},
  mounted() {
    
    if(this.$route.query.path && this.$route.query.path == 'missingyoustore'){
    window.location.href  = "https://standby.vip/#/"
    return
  }else if(this.$route.query.invitation || this.$route.query.invitations){
    window.location.href  = "https://apps.apple.com/cn/app/id6463835704"
    return
  }
  else{
     // 判断移动端或pc端
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (
      /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
        sUserAgent
      )
    ) {
      //跳转移动端页面
      if (window.location.hash == "#/mobileIndex/recordingappgoods") {
        this.$router.push({ path: "/mobileIndex/recordingappgoods" });
      }
      else if (window.location.hash == "#/mobileIndex/recordingappmb") {
        this.$router.push({ path: "/mobileIndex/recordingappmb" });
      }
      else if (window.location.hash == "#/mobileIndex/recordingapporder") {
        this.$router.replace({ path: "/mobileIndex/recordingapporder" });
      }else{
        this.$router.push({ path: "/mobileIndex" });
      }
    } else {
      //跳转PC端页面
      this.$router.push({ path: "/pcIndex" });
    }
  }
  },
};
</script>

<style>
html,
body {
  height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/App.vue